import React from "react";

interface Category {
  id: string;
  name: string;
  icon?: string; // Icon ist optional
}

interface FilterNavigationProps {
  categories: Category[];
  activeCategory: string;
  onSelectCategory: (categoryId: string) => void;
}

const FilterNavigation: React.FC<FilterNavigationProps> = ({ categories, activeCategory, onSelectCategory }) => {
  return (
    <nav style={navStyle}>
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onSelectCategory(category.id)}
          style={{
            ...buttonStyle,
            color: activeCategory === category.id ? "#c39d63" : "#514633",
          }}
        >
          {category.icon && <img src={category.icon} alt={category.name} style={iconStyle} />}
          <span style={textStyle}>{category.name}</span>
          <div
            style={{
              ...underlineStyle,
              backgroundColor: activeCategory === category.id ? "#c39d63" : "transparent",
            }}
          />
        </button>
      ))}
    </nav>
  );
};

const navStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  gap: "20px",
  padding: "10px 0",
  borderBottom: "1px solid #22242626",
  position: "relative",
};

const buttonStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  border: "none",
  background: "transparent",
  cursor: "pointer",
  padding: "10px",
  fontSize: "28px",
  fontFamily: "Avenir Next Codensed Ultralight",
  transition: "color 0.3s ease-in-out",
  position: "relative",
};

const iconStyle: React.CSSProperties = {
  width: "40px",
  height: "40px",
  marginBottom: "5px",
};

const textStyle: React.CSSProperties = {
  marginTop: "5px",
};

const underlineStyle: React.CSSProperties = {
  position: "absolute",
  bottom: "-11px",
  width: "170%",
  height: "1px",
  transition: "background-color 0.3s ease-in-out",
};

export default FilterNavigation;
